export default __webpack_public_path__ + "static/media/arrow-left-blue-icon.6d9d6833.svg";